import { Component, Input, OnInit, HostListener } from '@angular/core';
import { AboutDialogComponent } from 'src/app/core/components/about-dialog/about-dialog.component';
import { SupportDialogComponent } from 'src/app/core/components/support-dialog/support-dialog.component';
import { environment } from 'src/environments/environment';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';
import { CookieService } from 'ngx-cookie-service';
import { TranslationPipe } from 'src/app/shared/pipes/translation.pipe';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-footerlinks',
  providers: [TranslationPipe],
  template: `<div class="footer-links-container">
    <ul
      class="dark-background tw-w-full tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-center tw-gap-4 md:tw-gap-2"
    >
      <li class="tw-w-full md:tw-w-auto tw-text-center">
        <img
          src="assets/Images/Sedgwick_Footer_Logo.png"
          [attr.alt]="'Sedgwick Logo'"
          alt="Sedgwick Logo"
          class="tw-mx-auto md:tw-mx-0"
          style="max-height: 40px; width: auto;"
          (error)="onImageError($event)"
        />
      </li>

      <li class="tw-w-full md:tw-w-auto tw-text-center tw-uppercase footer-link">
        <a
          style="cursor: pointer;"
          tabindex="0"
          (click)="openSupportDialog()"
          (keydown.enter)="openSupportDialog()"
          role="button"
          [attr.aria-label]="'Opens Technical Support popup' | translation : translationRequest"
        >
          {{ 'Technical Support' | translation: translationRequest }}
        </a>
      </li>

      <span aria-hidden="true" class="tw-hidden md:tw-inline">|</span>

      <li class="tw-w-full md:tw-w-auto tw-text-center tw-uppercase footer-link">
        <a
          role="button"
          tabindex="0"
          (click)="openDialog()"
          (keydown.enter)="openDialog()"
          style="cursor: pointer;"
          [attr.aria-label]="'Opens About popup' | translation : translationRequest"
        >
          {{ 'About' | translation : translationRequest | sentenceCase }}
        </a>
      </li>

      <span aria-hidden="true" class="tw-hidden md:tw-inline">|</span>
      
      <li class="tw-w-full md:tw-w-auto tw-text-center tw-uppercase footer-link">
        <a
          href="https://www.sedgwick.com/privacy"
          target="_blank"
          [attr.aria-label]="'Opens privacy policy page in a new tab' | translation : translationRequest"
        >
          {{ 'Privacy Policy' | translation : translationRequest | sentenceCase }}
        </a>
      </li>

      <span aria-hidden="true" class="tw-hidden md:tw-inline">|</span>

      <li class="tw-w-full md:tw-w-auto tw-text-center tw-uppercase footer-link">
        <a
          href="https://www.sedgwick.com/termsandconditions"
          target="_blank"
          [attr.aria-label]="'Opens terms & conditions page in a new tab' | translation : translationRequest"
        >
          {{ 'Terms & Conditions' | translation : translationRequest }}
        </a>
      </li>
      
      <span aria-hidden="true" class="tw-hidden md:tw-inline">|</span>

      <li class="tw-w-full md:tw-w-auto tw-text-center tw-uppercase footer-link">
        <a
          [href]="helpFile"
          target="_blank"
          [attr.aria-label]="'Opens Help Page in a new tab' | translation : translationRequest"
        >
          {{ 'Help' | translation : translationRequest }}
        </a>
      </li>
      
      <ng-container *ngIf="AllowLoutURL">
        <span aria-hidden="true" class="tw-hidden md:tw-inline">|</span>
        <li class="tw-w-full md:tw-w-auto tw-text-center">
          <a>{{ 'Logout' | translation : translationRequest }}</a>
        </li>
      </ng-container>
      
      <li class="tw-w-full md:tw-w-auto tw-text-center tw-uppercase" *ngIf="availableLanguages && availableLanguages.size > 1">
         <button 
           tabindex="0" 
           id="language-open" 
           class="language-button" 
           (click)="toogleLanguage()"
           (keydown)="onLanguageKeydown($event)"
           [attr.aria-expanded]="showLangMenu"
          role="link"
           [attr.aria-label]="'Opens a list of available translation languages' | translation : translationRequest"
         >
             <div class="button-with-regions">                
                <p class="text-white">{{ selectedLanguageForFooter(selectedLanguageCode) | uppercase }}</p>
                
            </div>
            <div 
               id="language-menu"
               role="menu"
               *ngIf="showLangMenu && availableLanguages && availableLanguages.size > 1"
               class="regional-menu-is-open regional-nav"
             >
                <div class="scrollbar">
                    <div>  
                      <div class="regional-nav-title-div">
                            <p tabindex="0" id="languages-tab" class="regional-nav-title">{{ 'Select languages' | translation : translationRequest }}</p>
                        </div>               
                       <ul id="languages-list" class="regional-nav-item-div hide-list">
                                <li *ngFor="let language of availableLanguages | keyvalue : sortByValue; let i = index" 
                                    [attr.data-l]="language.key" 
                                    class="wg-li weglot-lang weglot-language" 
                                    [class.active-item]="selectedLanguageCode === language.key">
                                    <a class="regional-nav-item" 
                                       [class.active-item]="selectedLanguageCode === language.key"
                                       role="menuitem" 
                                       [tabindex]="showLangMenu ? 0 : -1"
                                       data-wg-notranslate="" 
                                       (click)="selectLanguage(language.key, language.value, $event)" 
                                       (keydown)="onLanguageMenuKeydown($event, language.key, language.value)"
                                       href="javascript:void(0)">
                                       {{ language.value }}
                                    </a>
                                </li>                                                        
                         </ul>
                    </div>
                </div>
            </div>
        </button>
      </li>
    </ul>
  </div> `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    
   /* .dark-background {
      background-color: var(--sed-engaged-black-color);
      padding: 1rem;
      border-radius: 0.5rem;
    }*/
    .dark-background a:focus
    {
      outline:none!important;
    }
    .language-button {
    position: relative;
    height: 42px;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;    
    padding-left: 18px;
    padding-right: 18px;
    cursor: pointer;
    font-weight:700;
    color: var(--sed-warm-white-color);
  }
    
    @media (min-width: 1024px) {
    .regional-nav {
        left: unset;
        right: 0px;
      }
    }
    @media (min-width: 640px) {
    .regional-nav {
        width: 200px;
      }
    } 
    .regional-nav{
      position: absolute;
    left: -3.25rem;
    bottom: 30px;
    z-index: 10;
    display: flex;
    width: 200px;
    border-radius: 0.375rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    opacity: 0;
    pointer-events: none;
    }
    
    /* Mobile-specific positioning for language dropdown */
    @media (max-width: 767px) {
      .regional-nav {
        left: auto;
        right: 0;
        width: 180px;
        max-width: calc(100vw - 2rem);
      }
    }
    .regional-menu-is-open {
    bottom: 50px!important;
    z-index: 1000!important;
    opacity: 1!important;
    pointer-events: auto!important;
    }
    .scrollbar {
    display: flex;
    flex: 1 1 0%;
    overflow-y: auto;
    scrollbar-color: #00f584 #212121;
    scrollbar-width: thin;
    height:300px;
    }
    .regional-nav .regional-nav-item-div {
    display: flex;
    height: -moz-fit-content;
    height: fit-content;
    flex-direction: column;
    padding: 0.25rem;
    text-align: start;
    gap:3px;
    }
    
    #language-open .button-with-regions {
    display: flex;
    cursor: pointer;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
}
.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.text-white:hover {
    text-decoration: underline;
    text-decoration-color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
}
.text-25-fresh-mint {
    --tw-text-opacity: 1;
    color: rgb(0 245 132 / var(--tw-text-opacity, 1));
}

.regional-nav-item {
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    text-decoration: none;
    display: block;
    padding: 0.5rem;
    border-radius: 0.25rem;
    transition: all 0.2s ease;
    border-width:1px;
    border-color:#000000;
    
}

/*.regional-nav-item:hover {
    background-color:  rgb(0 245 132 / var(--tw-text-opacity, 1));
    color:#000000;
    font-weight: 700;
}*/


.regional-nav-item.active-item {
    background-color: rgb(0 245 132 / var(--tw-text-opacity, 1));
    font-weight: 700;
    color:#000000;
    border-color:#000000;
    border-width:1px;
    border-style:solid;
    text-decoration: none;
}

.regional-nav-item:hover {
    background-color: rgb(0 245 132 / var(--tw-text-opacity, 1));
    font-weight: 700;
    color:#000000;
    border-color:#000000;
    border-width:1px;
    border-style:solid;
    text-decoration: none;
}

.regional-nav-item-div:has(.regional-nav-item:hover) .regional-nav-item.active-item:not(:hover) {
    background-color: transparent;
    font-weight: normal;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    border-color: #000000;
    border-width: 1px;
}

.regional-nav-title{
    --tw-text-opacity: 1;
    color: rgb(250 250 250 / var(--tw-text-opacity, 1));    
    text-decoration-color: #ffffff;
    text-decoration-thickness: 9%;
    text-underline-offset: 3.5px;
    font-weight:700;
}
    
.footer-link {
    color: #fff;
    font-weight: 700;
    letter-spacing: .2em;
}
    `],
})
export class FooterlinksComponent implements OnInit {
  @Input() isLogout: boolean;
  AllowLoutURL: boolean;
  helpFile: string;
  showLangMenu = false;
  clientData: { contNum: number } | null;
  showDebugInfo = true; // Set to false in production
  dialogRef: MatDialogRef<AboutDialogComponent | SupportDialogComponent> | undefined;
  selectedLanguageCode = 'en';

  translationRequest: TranslationRequest = new TranslationRequest(
    {
      language:sessionStorage.getItem('languagepreference'), // Default to English, you can make this dynamic
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'Shared',
      subGroup: 'Shared'
    }
  );

  // Variable to store languages from getLanguages() method
  availableLanguages = new Map<string, string>();
  allowMultipleLanguages: boolean;

  constructor(public dialog: MatDialog, public translationService: TranslationService, 
    private cookieService: CookieService, private translatePipe:TranslationPipe,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.translationService.isLanguagePreferenceSet()) {
      this.selectedLanguageCode = sessionStorage.getItem("languagepreference");
    }

  }

  toogleLanguage(): void {
    this.showLangMenu = !this.showLangMenu;
  }

  selectedLanguageForFooter(selectedLanguageCode: string) {
    if (selectedLanguageCode != undefined && selectedLanguageCode != null && selectedLanguageCode.length > 1) {
      if (selectedLanguageCode?.toLocaleLowerCase() == 'en') {
        return this.availableLanguages.get(selectedLanguageCode);
      }
      else{
        return this.availableLanguages.get(selectedLanguageCode);
      }
    }
    else{
      return this.availableLanguages.get(selectedLanguageCode);
    }
  }
  selectLanguage(languageCode: string, languageName: string, event: Event): void {
    event.preventDefault();
    this.showLangMenu = false;
    
    // Wait for setDefaultLanguage (API call) to complete before continuing
    this.translationService.setDefaultLanguage(languageCode).subscribe({
      next: () => {
        // Clear translation cache after API call completes
        this.translationService.clearTranslationCache();
        
        sessionStorage.setItem("languagepreference", languageCode);
        sessionStorage.setItem("languageInitialized", "true");
        
        // Reload page after everything is done
         if(this.activatedRoute.snapshot.queryParams['language'] != undefined)
        {
          const queryParams = new URLSearchParams(window.location.search); 
          queryParams.set('language',languageCode);        
          window.location.search = queryParams.toString();
        }
        else{
          window.location.reload();
        }
        
      },
      error: (error) => {
        console.error('Failed to set language preference:', error);
        // Execute remaining steps even if API call fails
        this.translationService.clearTranslationCache();
        sessionStorage.setItem("languagepreference", languageCode);
        sessionStorage.setItem("languageInitialized", "true");
        window.location.reload();
      }
    });
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
    console.warn('Footer logo image failed to load:', img.src);
  }

  onLanguageKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toogleLanguage();
      
      // Focus first menu item when opening
      if (this.showLangMenu) {
        setTimeout(() => {
          const firstMenuItem = document.querySelector('#languages-list .regional-nav-item') as HTMLElement;
          if (firstMenuItem) {
            firstMenuItem.focus();
          }
        }, 0);
      }
    } else if (event.key === 'ArrowDown' && this.showLangMenu) {
      event.preventDefault();
      this.focusFirstMenuItem();
    }
  }

  onLanguageMenuKeydown(event: KeyboardEvent, languageKey: string, languageValue: string): void {
    const menuItems = Array.from(document.querySelectorAll('#languages-list .regional-nav-item')) as HTMLElement[];
    const currentIndex = menuItems.findIndex(item => item === event.target);

    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.selectLanguage(languageKey, languageValue, event);
        break;
        
      case 'ArrowDown': {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % menuItems.length;
        menuItems[nextIndex].focus();
        break;
      }
        
      case 'ArrowUp': {
        event.preventDefault();
        const prevIndex = currentIndex === 0 ? menuItems.length - 1 : currentIndex - 1;
        menuItems[prevIndex].focus();
        break;
      }
        
      case 'Escape': {
        event.preventDefault();
        this.showLangMenu = false;
        const languageButton = document.getElementById('language-open') as HTMLElement;
        if (languageButton) {
          languageButton.focus();
        }
        break;
      }
        
      case 'Tab':
        // Allow natural tab navigation through menu items
        if (event.shiftKey && currentIndex === 0) {
          // Shift+Tab from first item - close menu and focus button
          event.preventDefault();
          this.showLangMenu = false;
          const languageButton = document.getElementById('language-open') as HTMLElement;
          if (languageButton) {
            languageButton.focus();
          }
        } else if (!event.shiftKey && currentIndex === menuItems.length - 1) {
          // Tab from last item - close menu and continue to next focusable element
          this.showLangMenu = false;
        }
        break;
    }
  }

  private focusFirstMenuItem(): void {
    setTimeout(() => {
      const firstMenuItem = document.querySelector('#languages-list .regional-nav-item') as HTMLElement;
      if (firstMenuItem) {
        firstMenuItem.focus();
      }
    }, 0);
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    if (this.showLangMenu) {
      this.showLangMenu = false;
      event.preventDefault();
      event.stopPropagation();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const languageButton = target.closest('#language-open');
    const regionalNav = target.closest('#language-menu');
    const footerLink = target.closest('.footer-link');
    
    // If clicking on a footer link that's not the language button, ensure language menu is closed
    if (footerLink && !languageButton && this.showLangMenu) {
      this.showLangMenu = false;
      return;
    }
    
    // Close the menu if clicking outside both the button and the menu
    if (this.showLangMenu && !languageButton && !regionalNav) {
      this.showLangMenu = false;
    }
  }

  async ngOnInit(): Promise<void> {
    this.AllowLoutURL = this.isLogout;
    this.helpFile = environment.helpFile;
    this.clientData = JSON.parse(sessionStorage.getItem('clientData'));
    
    if (this.translationService) {
      try {
       if(this.translationService.isMultiLanagueFeatureEnabled()){
        this.allowMultipleLanguages = true;
       }
       else{
        this.allowMultipleLanguages = false;
       }
        if (this.allowMultipleLanguages) {
          await this.loadAvailableLanguages();
        }
      } catch (error) {
        console.warn('Translation service not available yet:', error);
      }
    }
   
    // Initialize translation service if available
   }

  loadAvailableLanguages(): void {
    // Call getLanguages() method and store result in availableLanguages variable
    if (!this.clientData?.contNum) {
      return;
    }
    this.translationService.getLanguages(this.clientData.contNum).subscribe({
        next: (languages: Record<string, string>) => {
          const lang = Object.entries(languages);
          this.availableLanguages = new Map(Object.entries(languages));
          this.availableLanguages = new Map(lang);
          if(this.availableLanguages.size > 1) {
            this.allowMultipleLanguages = true;

            // Check if we've already handled the language preference to prevent reload loops
            const languageInitialized = sessionStorage.getItem('languageInitialized');
            if (languageInitialized === 'true') {
              // Language already initialized, just set the selected code from session
              const currentSessionLanguage = sessionStorage.getItem('languagepreference');
              if (currentSessionLanguage && this.availableLanguages.get(currentSessionLanguage)) {
                this.selectedLanguageCode = currentSessionLanguage;
              }
              return;
            }

            // First check if cookie exists for language preference
            const languageFromCookie = this.cookieService.get('LanguagePreferenceCookie');
            const currentSessionLanguage = sessionStorage.getItem('languagepreference');

            if(languageFromCookie && this.availableLanguages.get(languageFromCookie))
            {
              this.selectedLanguageCode = languageFromCookie;
              
              if(languageFromCookie !== currentSessionLanguage)
              {
                sessionStorage.setItem("languagepreference", languageFromCookie);
                sessionStorage.setItem("languageInitialized", "true");
                
                this.translationService.setLanguagePreferenceCookie(languageFromCookie);

                if(languageFromCookie !== 'en')
                {
                  window.location.reload();
                }                
              }
              else {
                sessionStorage.setItem("languageInitialized", "true");
              }

            }
            else{
              let selectedLangCode = this.getBrowserLanguage();
              if(selectedLangCode !== 'en' && this.availableLanguages.get(selectedLangCode) && selectedLangCode !== currentSessionLanguage)
              {
                this.selectedLanguageCode = selectedLangCode;
                
                sessionStorage.setItem("languagepreference", selectedLangCode);
                sessionStorage.setItem("languageInitialized", "true");

                this.translationService.setLanguagePreferenceCookie(selectedLangCode);

                window.location.reload();
              }
              else {
                // No reload needed, mark as initialized
                sessionStorage.setItem("languageInitialized", "true");
              }
            }

            }
        },
        error: (error) => {
          console.error('Error loading available languages:', error);
          // Set default empty object on error
          this.availableLanguages = new Map<string, string>();
        }
      });
  }

  getBrowserLanguage(): string {
    let browserLanguage =  navigator.language || navigator.languages?.[0] || 'en';
    browserLanguage = browserLanguage.toLowerCase().startsWith('en') ? 'en' : browserLanguage.toLowerCase().substring(0, 2);
    return browserLanguage.toString();
  }


  sortByValue = (a: { key: string, value: string }, b: { key: string, value: string }): number => {
    return a.value.localeCompare(b.value);
  }



  openDialog(): void {
    this.translationService.getTranslationForKey$('About Dialog').subscribe((ariaLabel) => {
      const dialogRef = this.dialog.open(AboutDialogComponent, {
        width: '500px',
        disableClose: true,
        autoFocus: true,
        role: 'dialog',
        ariaLabel: ariaLabel,
      });

      dialogRef.keydownEvents().subscribe((event) => {
        if (event.key === 'Escape') {
          this.dialog.closeAll();
        }
      });
    });
  }

  openSupportDialog(): void {
    this.translationService.getTranslationForKey$('Technical Support Dialog').subscribe((ariaLabel) => {
      const dialogRef = this.dialog.open(SupportDialogComponent, {
        width: '500px',
        disableClose: true,
        autoFocus: true,
        role: 'dialog',
        ariaLabel: ariaLabel,
      });

      dialogRef.keydownEvents().subscribe((event) => {
        if (event.key === 'Escape') {
          this.dialog.closeAll();
        }
      });
    });
  }
}